import { render } from "./UserTab.vue?vue&type=template&id=0420d3d0&scoped=true"
import script from "./UserTab.vue?vue&type=script&lang=js"
export * from "./UserTab.vue?vue&type=script&lang=js"

import "./UserTab.vue?vue&type=style&index=0&id=0420d3d0&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0420d3d0"]])

export default __exports__